<template>
  <button
    class="inline-flex items-center px-3 py-1 text-sm bg-primary/10 text-primary rounded-lg hover:bg-primary/20 transition-colors"
    @click="$emit('click')"
  >
    {{ label }}
    <Icon name="heroicons:x-mark" class="w-4 h-4 ml-1" />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>
